import client from "./client";

export function getScheduleTypes(limit = 0, offset = 0) {
  return client
    .get(`/api/schedule_types/?limit=${limit}&offset=${offset}`)
    .then((res) => res.data);
}

export function addScheduleType(body) {
  return client.post("/api/schedule_types/", body).then((res) => res.data);
}

export function setScheduleType(body) {
  return client
    .put(`/api/schedule_types/${body.id}/`, body)
    .then((res) => res.data);
}

export function deleteScheduleType(body) {
  return client
    .delete(`/api/schedule_types/${body.id}/`)
    .then((res) => res.data);
}
